import React, { useState, useEffect } from "react";
import api from "../services/api";
import ModalUbicaciones from "../components/ModalUbicaciones";

const Materiales = () => {
  const [materiales, setMateriales] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [archivo, setArchivo] = useState(null);
  const [almacenes, setAlmacenes] = useState([]);
  const [unidades, setUnidades] = useState([]);
  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [filtroCategoria, setFiltroCategoria] = useState("");
  const [busqueda, setBusqueda] = useState("");
  const [materialEditando, setMaterialEditando] = useState(null); 
  const usuario = JSON.parse(localStorage.getItem("usuario")); // ← NUEVO
  const [modalUbicaciones, setModalUbicaciones] = useState(null);
  const [primerMaterial, setPrimerMaterial] = useState(false);
  const [ubicacionesData, setUbicacionesData] = useState(null);

  const [form, setForm] = useState({
    codigo: "",
    nombre: "",
    descripcion: "",
    CategoriaId: "",
    unidad: "",
    ubicacion: "",
    existencia_inicial: "",
    costo_unitario_inicial: "",
    valor_inicial: "",
    AlmacenId: "",
  });

  const obtenerMateriales = async () => {
    try {
      const res = await api.get("/materiales");
      setMateriales(res.data);
    } catch (error) {
      console.error("Error al cargar materiales:", error);
    }
  };

  const obtenerCategorias = async () => {
    try {
      const res = await api.get("/categorias");
      setCategorias(res.data);
    } catch (error) {
      console.error("Error al cargar categorías:", error);
    }
  };

  const obtenerAlmacenes = async () => {
  try {
    const res = await api.get("/almacenes");
    // Filtrar solo almacenes principales y activos
    const principales = res.data.filter(alm => alm.tipo === "principal" && alm.activo);
    setAlmacenes(principales);
  } catch (error) {
    console.error("Error al cargar almacenes:", error);
  }
};

const obtenerUnidades = async () => {
  try {
    const res = await api.get("/unidades-medida");
    setUnidades(res.data);
  } catch (error) {
    console.error("Error al cargar unidades:", error);
  }
};

const verUbicaciones = async (material) => {
  try {
    const res = await api.get(`/materiales/${material.id}/ubicaciones`);
    setModalUbicaciones(material);
    setUbicacionesData(res.data);
  } catch (error) {
    console.error('Error al cargar ubicaciones:', error);
    alert('Error al cargar las ubicaciones del material');
  }
};

  const guardarMaterialEditado = async () => {
    if (!materialEditando.codigo || !materialEditando.nombre) {
        alert("⚠️ Código y nombre son obligatorios.");
        return;
    }

    const payload = {
        codigo: materialEditando.codigo,
        nombre: materialEditando.nombre,
        descripcion: materialEditando.descripcion,
        CategoriaId: materialEditando.CategoriaId,
        unidad: materialEditando.unidad,
        ubicacion: materialEditando.ubicacion,
        // Campos POS
        disponible_pos: materialEditando.disponible_pos || false,
        porcentaje_ganancia: materialEditando.porcentaje_ganancia || 30,
        precio_venta: materialEditando.precio_venta || 0,
    };

    try {
        await api.put(`/materiales/${materialEditando.id}`, payload);
        alert("✅ Material actualizado correctamente.");
        setMaterialEditando(null);
        obtenerMateriales();
    } catch (error) {
        console.error("Error al guardar edición:", error);
        alert(error.response?.data?.mensaje || "❌ Error al actualizar material. (Verifique permisos)");
    }
  };

  const agregarMaterial = async () => {
    if (!form.codigo || !form.nombre) {
      alert("⚠️ El código y nombre son obligatorios");
      return;
    }

    try {
      await api.post("/materiales", form);
      setForm({
        codigo: "",
        nombre: "",
        descripcion: "",
        CategoriaId: "",
        AlmacenId: "", 
        unidad: "",
        ubicacion: "",
        existencia_inicial: "",
        costo_unitario_inicial: "",
        valor_inicial: "",
      });
      obtenerMateriales();
      setMostrarFormulario(false);
      alert("✅ Material agregado correctamente");
    } catch (error) {
      console.error("Error al agregar material:", error);
      alert("❌ No se pudo agregar el material");
    }
  };

  const importarArchivo = async () => {
    if (!archivo) {
      alert("Selecciona un archivo Excel primero");
      return;
    }

    const formData = new FormData();
    formData.append("file", archivo);

    try {
     await api.post("/importar", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("✅ Archivo importado correctamente");
      setArchivo(null);
      obtenerMateriales();
    } catch (error) {
      console.error("Error al importar:", error);
      alert("❌ Error al importar el archivo");
    }
  };

  useEffect(() => {
    const cargarTodo = async () => {
      const res = await obtenerMateriales();
      obtenerCategorias();
      obtenerAlmacenes();
      obtenerUnidades();
    };
    cargarTodo();
  }, []);

  useEffect(() => {
    const obtenerProximoCodigo = async () => {
      try {
        const res = await api.get("/materiales/proximo-codigo");
        setForm((prev) => ({ ...prev, codigo: res.data.proximoCodigo }));
      } catch (error) {
        console.error("Error al obtener el próximo código:", error);
      }
    };

    if (mostrarFormulario) {
      obtenerProximoCodigo();
    }
  }, [mostrarFormulario]);

  const materialesFiltrados = materiales.filter((m) => {
    const coincideBusqueda = 
      m.codigo?.toLowerCase().includes(busqueda.toLowerCase()) ||
      m.nombre?.toLowerCase().includes(busqueda.toLowerCase()) ||
      m.descripcion?.toLowerCase().includes(busqueda.toLowerCase());
    
    const coincideCategoria = filtroCategoria === "" || m.CategoriaId === parseInt(filtroCategoria);
    
    return coincideBusqueda && coincideCategoria;
  });

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.headerContent}>
          <h1 style={styles.title}>📦 Catálogo de Materiales</h1>
          <p style={styles.subtitle}>Gestiona tu inventario de materiales</p>
        </div>
        <button
          style={styles.btnPrimary}
          onClick={() => setMostrarFormulario(!mostrarFormulario)}
        >
          {mostrarFormulario ? "❌ Cancelar" : "➕ Nuevo Material"}
        </button>
      </div>

      {/* Importar Excel */}
      <div style={styles.card}>
        <h3 style={styles.cardTitle}>📂 Importar desde Excel</h3>
        <div style={styles.uploadSection}>
          <input
            type="file"
            accept=".xlsx, .xls"
            onChange={(e) => setArchivo(e.target.files[0])}
            style={styles.fileInput}
          />
          <button
            onClick={importarArchivo}
            style={{...styles.btnSecondary, opacity: archivo ? 1 : 0.5}}
            disabled={!archivo}
          >
            📤 Importar Archivo
          </button>
          {archivo && (
            <span style={styles.fileName}>
              ✓ {archivo.name}
            </span>
          )}
        </div>
      </div>

      {/* ⭐ Banner primer material */}
      {primerMaterial && !mostrarFormulario && (
        <div style={{
          background: '#eff6ff',
          border: '1px solid #3b82f6',
          borderRadius: '12px',
          padding: '16px 20px',
          marginBottom: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '16px'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ fontSize: '24px' }}>📦</span>
            <div>
              <p style={{ margin: 0, fontWeight: '700', color: '#1d4ed8', fontSize: '14px' }}>
                Aún no tienes materiales registrados
              </p>
              <p style={{ margin: '2px 0 0', color: '#3b82f6', fontSize: '13px' }}>
                Puedes definir tu propio código (ej: <strong>GV-001</strong>, <strong>MAT-001</strong>) o dejarlo vacío y el sistema lo genera automáticamente.
              </p>
            </div>
          </div>
          <button
            onClick={() => setMostrarFormulario(true)}
            style={{
              padding: '10px 18px',
              background: '#3b82f6',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '13px',
              fontWeight: '700',
              cursor: 'pointer',
              whiteSpace: 'nowrap'
            }}
          >
            ➕ Crear Primer Material
          </button>
        </div>
      )}

      {/* Formulario de Nuevo Material */}
      {mostrarFormulario && (
        <div style={styles.card}>
          <h3 style={styles.cardTitle}>📝 Agregar Nuevo Material</h3>
          <div style={styles.formGrid}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Código *</label>
              <input
                type="text"
                style={{ ...styles.input, fontWeight: "bold" }}
                value={form.codigo}
                onChange={(e) => setForm({ ...form, codigo: e.target.value })}
                placeholder="Ej: MAT-001, GV-001, 123456..."
              />
              <small style={{ color: '#64748b', fontSize: '11px', marginTop: '4px' }}>
                Puedes modificarlo o dejarlo para que se genere automáticamente
              </small>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Nombre *</label>
              <input
                type="text"
                style={styles.input}
                value={form.nombre}
                onChange={(e) => setForm({ ...form, nombre: e.target.value })}
                placeholder="Nombre del material"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Descripción</label>
              <input
                type="text"
                style={styles.input}
                value={form.descripcion}
                onChange={(e) => setForm({ ...form, descripcion: e.target.value })}
                placeholder="Descripción detallada"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Categoría</label>
              <select
                style={styles.select}
                value={form.CategoriaId}
                onChange={(e) => setForm({ ...form, CategoriaId: e.target.value })}
              >
                <option value="">— Selecciona —</option>
                {categorias.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.nombre}
                  </option>
                ))}
              </select>
            </div>

          <div style={styles.formGroup}>
  <label style={styles.label}>Almacén *</label>
  <select
    style={styles.select}
    value={form.AlmacenId}
    onChange={(e) => setForm({ ...form, AlmacenId: e.target.value })}
    required
  >
    <option value="">-- Selecciona almacén --</option>
    {almacenes.map((alm) => (
      <option key={alm.id} value={alm.id}>
        {alm.nombre} ({alm.codigo})
      </option>
    ))}
  </select>
</div>

           <div style={styles.formGroup}>
  <label style={styles.label}>Unidad *</label>
  <select
    style={styles.select}
    value={form.unidad}
    onChange={(e) => setForm({ ...form, unidad: e.target.value })}
    required
  >
    <option value="">-- Selecciona unidad --</option>
    {unidades
      .filter(u => u.activo)
      .map((unidad) => (
        <option key={unidad.id} value={unidad.codigo}>
          {unidad.nombre} {unidad.simbolo ? `(${unidad.simbolo})` : ''}
        </option>
      ))}
  </select>
</div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Existencia Inicial</label>
              <input
                type="number"
                step="0.01"
                style={styles.input}
                value={form.existencia_inicial}
                onChange={(e) => setForm({ ...form, existencia_inicial: e.target.value })}
                placeholder="0"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Costo Unitario Inicial (RD$)</label>
              <input
                type="number"
                step="0.01"
                style={styles.input}
                value={form.costo_unitario_inicial}
                onChange={(e) => setForm({ ...form, costo_unitario_inicial: e.target.value })}
                placeholder="0.00"
              />
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Valor Inicial (RD$)</label>
              <input
                type="number"
                step="0.01"
                style={styles.input}
                value={form.valor_inicial}
                onChange={(e) => setForm({ ...form, valor_inicial: e.target.value })}
                placeholder="0.00"
              />
            </div>
          </div>

          <div style={styles.formActions}>
            <button onClick={agregarMaterial} style={styles.btnSuccess}>
              ✓ Guardar Material
            </button>
            <button
              onClick={() => setMostrarFormulario(false)}
              style={styles.btnCancel}
            >
              Cancelar
            </button>
          </div>
        </div>
      )}

      {/* Filtros y Búsqueda */}
      <div style={styles.filtersCard}>
        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>🔍 Buscar:</label>
          <input
            type="text"
            style={styles.searchInput}
            placeholder="Buscar por código, nombre o descripción..."
            value={busqueda}
            onChange={(e) => setBusqueda(e.target.value)}
          />
        </div>

        <div style={styles.filterGroup}>
          <label style={styles.filterLabel}>🏷️ Categoría:</label>
          <select
            style={styles.filterSelect}
            value={filtroCategoria}
            onChange={(e) => setFiltroCategoria(e.target.value)}
          >
            <option value="">Todas las categorías</option>
            {categorias.map((c) => (
              <option key={c.id} value={c.id}>
                {c.nombre}
              </option>
            ))}
          </select>
        </div>

        <div style={styles.filterStats}>
          <span style={styles.statsText}>
            📊 Mostrando {materialesFiltrados.length} de {materiales.length} materiales
          </span>
        </div>
      </div>

      {/* Tabla de Materiales */}
      <div style={styles.tableCard}>
        <h3 style={styles.cardTitle}>📋 Lista de Materiales</h3>
        <div style={styles.tableWrapper}>
          <table style={styles.table}>
            <thead>
              <tr>
                <th style={styles.th}>Código</th>
                <th style={styles.th}>Nombre</th>
                <th style={styles.th}>Descripción</th>
                <th style={styles.th}>Categoría</th>
                <th style={styles.th}>Ubicación</th>
                <th style={styles.th}>Unidad</th>
                <th style={styles.th}>Exist. Inicial</th>
                <th style={styles.th}>Costo Unit.</th>
                <th style={styles.th}>Valor Inicial</th>
                <th style={styles.th}>Stock Actual</th>
                <th style={styles.th}>POS</th>
                <th style={styles.th}>Acciones</th> 
              </tr>
            </thead>
            <tbody>
              {materialesFiltrados.length === 0 ? (
                <tr>
                  <td colSpan="12" style={styles.emptyRow}> 
                    {materiales.length === 0 
                      ? "No hay materiales registrados" 
                      : "No se encontraron materiales con los filtros aplicados"}
                  </td>
                </tr>
              ) : (
                materialesFiltrados.map((m) => (
                  <tr 
                    key={m.id} 
                    style={styles.tr}
                    onMouseEnter={(e) => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={(e) => e.currentTarget.style.background = 'white'}
                  >
                    <td style={styles.td}>{m.codigo}</td>
                    <td style={styles.td}><strong>{m.nombre}</strong></td>
                    <td style={styles.td}>{m.descripcion || "-"}</td>
                    <td style={styles.td}>
                      {categorias.find(c => c.id === m.CategoriaId)?.nombre || "-"}
                    </td>
                    <td style={styles.td}>{m.ubicacion || "-"}</td>
                    <td style={styles.td}>{m.unidad || "-"}</td>
                    <td style={styles.td}>{m.existencia_inicial || 0}</td>
                    <td style={styles.td}>RD$ {parseFloat(m.costo_unitario_inicial || 0).toFixed(2)}</td>
                    <td style={styles.td}>RD$ {parseFloat(m.valor_inicial || 0).toFixed(2)}</td>
                    <td style={{...styles.td, fontWeight: 'bold', color: '#2196F3'}}>
                      {m.stock_actual || 0}
                    </td>
                    <td style={styles.td}>
                      {m.disponible_pos ? (
                        <span style={styles.badgePOS}>✓ RD${parseFloat(m.precio_venta || 0).toFixed(2)}</span>
                      ) : (
                        <span style={styles.badgeNoPOS}>—</span>
                      )}
                    </td>
                   <td style={styles.tdActions}> 
  <button 
    onClick={() => verUbicaciones(m)}
    style={styles.btnUbicaciones}
    title="Ver ubicaciones"
  >
    📍
  </button>
  
  <button 
    onClick={() => setMaterialEditando({ 
        id: m.id, 
        codigo: m.codigo,
        nombre: m.nombre,
        descripcion: m.descripcion,
        CategoriaId: m.CategoriaId,
        unidad: m.unidad,
        ubicacion: m.ubicacion,
        costo_unitario_inicial: m.costo_unitario_inicial,
        valor_inicial: m.valor_inicial,
        stock_actual: m.stock_actual,
        disponible_pos: m.disponible_pos || false,
        porcentaje_ganancia: m.porcentaje_ganancia || 30,
        precio_venta: m.precio_venta || 0
    })}
    style={styles.btnEdit} 
  >
    ✏️ Editar
  </button>
</td>

                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

    
      {/* MODAL DE EDICIÓN */}
      {materialEditando && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <h3 style={styles.modalTitle}>
              ✏️ Editando: {materialEditando.nombre}
            </h3>

            <div style={styles.formGrid}>
        
              <div style={styles.formGroup}>
                <label style={styles.label}>Código *</label>
                <input
                  type="text"
                  style={styles.input}
                  value={materialEditando.codigo}
                  onChange={(e) => setMaterialEditando({...materialEditando, codigo: e.target.value})}
                />
              </div>

         
              <div style={styles.formGroup}>
                <label style={styles.label}>Nombre *</label>
                <input
                  type="text"
                  style={styles.input}
                  value={materialEditando.nombre}
                  onChange={(e) => setMaterialEditando({...materialEditando, nombre: e.target.value})}
                />
              </div>

        
              <div style={styles.formGroup}>
                <label style={styles.label}>Descripción</label>
                <input
                  type="text"
                  style={styles.input}
                  value={materialEditando.descripcion || ''}
                  onChange={(e) => setMaterialEditando({...materialEditando, descripcion: e.target.value})}
                />
              </div>

     
              <div style={styles.formGroup}>
                <label style={styles.label}>Categoría</label>
                <select
                  style={styles.select}
                  value={materialEditando.CategoriaId || ''}
                  onChange={(e) => setMaterialEditando({...materialEditando, CategoriaId: parseInt(e.target.value) || null})}
                >
                  <option value="">— Selecciona —</option>
                  {categorias.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.nombre}
                    </option>
                  ))}
                </select>
              </div>

    
              <div style={styles.formGroup}>
                <label style={styles.label}>Unidad</label>
                <select
  style={styles.select}
  value={materialEditando.unidad}
  onChange={(e) => setMaterialEditando({ 
    ...materialEditando, 
    unidad: e.target.value 
  })}
>
                  <option value="">-- Selecciona unidad --</option>
  {unidades
    .filter(u => u.activo)
    .map((unidad) => (
      <option key={unidad.id} value={unidad.codigo}>
        {unidad.nombre} {unidad.simbolo ? `(${unidad.simbolo})` : ''}
      </option>
    ))}
</select>
              </div>

              <div style={styles.formGroup}>
  <label style={styles.label}>Almacén</label>
  <select
    style={styles.select}
    value={materialEditando.AlmacenId || ''}
    onChange={(e) => setMaterialEditando({...materialEditando, AlmacenId: e.target.value})}
  >
    <option value="">-- Selecciona almacén --</option>
    {almacenes.map((alm) => (
      <option key={alm.id} value={alm.id}>
        {alm.nombre} ({alm.codigo})
      </option>
    ))}
  </select>
</div>
              
          
              <div style={styles.formGroup}>
                <label style={styles.label}>Stock Actual</label>
                <input
                  type="number"
                  style={{...styles.input, backgroundColor: '#f1f5f9'}}
                  value={materialEditando.stock_actual || 0}
                  readOnly={true}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Costo Unitario (RD$)</label>
                <input
                  type="number"
                  style={{...styles.input, backgroundColor: '#f1f5f9'}}
                  value={materialEditando.costo_unitario_inicial || ''}
                  readOnly={true}
                />
              </div>
              
              <div style={styles.formGroup}>
                <label style={styles.label}>Valor Inicial (RD$)</label>
                <input
                  type="number"
                  style={{...styles.input, backgroundColor: '#f1f5f9'}}
                  value={materialEditando.valor_inicial || ''}
                  readOnly={true}
                />
              </div>

            </div>

            {/* ═══════════════════════════════════════════════════════════════ */}
            {/* 🛒 SECCIÓN POS - Solo visible para roles autorizados */}
            {/* ═══════════════════════════════════════════════════════════════ */}
            {['superadmin', 'admin', 'supervisor_pos'].includes(usuario?.rol) && (
              <div style={styles.posSection}>
                <h4 style={styles.posSectionTitle}>🛒 Configuración para Punto de Venta</h4>
                
                <div style={styles.posToggle}>
                  <label style={styles.toggleLabel}>
                    <input
                      type="checkbox"
                      checked={materialEditando.disponible_pos || false}
                      onChange={(e) => setMaterialEditando({
                        ...materialEditando, 
                        disponible_pos: e.target.checked
                      })}
                      style={styles.checkbox}
                    />
                    <span style={styles.toggleText}>Disponible para venta en POS</span>
                  </label>
                </div>

                {materialEditando.disponible_pos && (
                  <div style={styles.posFields}>
                    <div style={styles.formGroup}>
                      <label style={styles.label}>% Ganancia</label>
                      <input
                        type="number"
                        style={styles.input}
                        value={materialEditando.porcentaje_ganancia || 30}
                        onChange={(e) => {
                          const porcentaje = parseFloat(e.target.value) || 0;
                          const costo = parseFloat(materialEditando.costo_unitario_inicial) || 0;
                          const precioCalculado = costo * (1 + porcentaje / 100);
                          setMaterialEditando({
                            ...materialEditando,
                            porcentaje_ganancia: porcentaje,
                            precio_venta: precioCalculado.toFixed(2)
                          });
                        }}
                        min="0"
                        max="500"
                      />
                    </div>

                    <div style={styles.formGroup}>
                      <label style={styles.label}>Precio de Venta (RD$)</label>
                      <input
                        type="number"
                        step="0.01"
                        style={{...styles.input, fontWeight: 'bold', color: '#10b981'}}
                        value={materialEditando.precio_venta || 0}
                        onChange={(e) => setMaterialEditando({
                          ...materialEditando,
                          precio_venta: e.target.value
                        })}
                        min="0"
                      />
                    </div>

                    <div style={styles.posPreview}>
                      <span>Costo: RD$ {parseFloat(materialEditando.costo_unitario_inicial || 0).toFixed(2)}</span>
                      <span>→</span>
                      <span style={{color: '#10b981', fontWeight: 'bold'}}>
                        Venta: RD$ {parseFloat(materialEditando.precio_venta || 0).toFixed(2)}
                      </span>
                    </div>
                    
                  </div>
                )}
              </div>
            )}
            
            {/* ACCIONES DEL MODAL */}
            <div style={styles.modalActions}>
              <button 
                style={styles.btnCancel} 
                onClick={() => setMaterialEditando(null)}
              >
                Cancelar
              </button>
              <button 
                style={styles.btnSuccess} 
                onClick={() => guardarMaterialEditado()}
              >
                Guardar Cambios
              </button>
            </div>
          </div>
        </div>
      )}

          {/* ✅ MODAL DE UBICACIONES */}
      {modalUbicaciones && ubicacionesData && (
        <ModalUbicaciones
          material={modalUbicaciones}
          ubicaciones={ubicacionesData.ubicaciones}
          resumen={ubicacionesData.resumen}
          onClose={() => {
            setModalUbicaciones(null);
            setUbicacionesData(null);
          }}
        />
      )}
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    background: '#f8fafc',
    padding: '20px',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '25px',
    flexWrap: 'wrap',
    gap: '15px',
  },
  headerContent: {
    flex: '1',
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: '#1e293b',
    margin: '0 0 5px 0',
  },
  subtitle: {
    fontSize: '14px',
    color: '#64748b',
    margin: '0',
  },
  btnPrimary: {
    padding: '12px 24px',
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '10px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
    transition: 'all 0.2s ease',
  },
  card: {
    background: 'white',
    borderRadius: '12px',
    padding: '25px',
    marginBottom: '20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
  },
  cardTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  uploadSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    flexWrap: 'wrap',
  },
  fileInput: {
    padding: '8px',
    fontSize: '14px',
    border: '2px dashed #cbd5e1',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  btnSecondary: {
    padding: '10px 20px',
    background: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  },
  fileName: {
    fontSize: '13px',
    color: '#10b981',
    fontWeight: '500',
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '20px',
    marginBottom: '20px',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
    marginBottom: '6px',
  },
  input: {
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
    transition: 'all 0.2s ease',
  },
  select: {
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
    background: 'white',
    cursor: 'pointer',
  },
  formActions: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
  },
  btnSuccess: {
    padding: '12px 24px',
    background: '#10b981',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  btnCancel: {
    padding: '12px 24px',
    background: '#94a3b8',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: '600',
    cursor: 'pointer',
  },
  filtersCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '20px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
    display: 'flex',
    gap: '20px',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    flex: '1',
    minWidth: '250px',
  },
  filterLabel: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#475569',
    whiteSpace: 'nowrap',
  },
  searchInput: {
    flex: '1',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
  },
  filterSelect: {
    flex: '1',
    padding: '10px 12px',
    fontSize: '14px',
    border: '1px solid #cbd5e1',
    borderRadius: '8px',
    outline: 'none',
    background: 'white',
    cursor: 'pointer',
  },
  filterStats: {
    padding: '10px 16px',
    background: '#f1f5f9',
    borderRadius: '8px',
  },
  statsText: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#475569',
  },
  tableCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '25px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
    border: '1px solid #e2e8f0',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    fontSize: '13px',
  },

  btnUbicaciones: {
  padding: '8px 12px',
  background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
  color: 'white',
  border: 'none',
  borderRadius: '8px',
  fontSize: '16px',
  cursor: 'pointer',
  marginRight: '8px',
  boxShadow: '0 2px 4px rgba(59, 130, 246, 0.2)',
  transition: 'all 0.2s',
},
  th: {
    background: '#f8fafc',
    padding: '12px',
    textAlign: 'left',
    fontWeight: '700',
    color: '#475569',
    borderBottom: '2px solid #e2e8f0',
    whiteSpace: 'nowrap',
  },
  tr: {
    transition: 'background 0.2s ease',
  },
  td: {
    padding: '12px',
    borderBottom: '1px solid #f1f5f9',
    color: '#1e293b',
  },
  emptyRow: {
    padding: '40px',
    textAlign: 'center',
    color: '#94a3b8',
    fontStyle: 'italic',
  },
  badgePOS: {
    display: 'inline-block',
    padding: '4px 8px',
    background: '#d1fae5',
    color: '#065f46',
    borderRadius: '6px',
    fontSize: '11px',
    fontWeight: '700',
  },
  badgeNoPOS: {
    display: 'inline-block',
    padding: '4px 8px',
    background: '#f1f5f9',
    color: '#94a3b8',
    borderRadius: '6px',
    fontSize: '11px',
  },
  modalOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  modalContent: {
    background: 'white',
    borderRadius: '16px',
    padding: '30px',
    width: '90%',
    maxWidth: '800px',
    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.2)',
  },
  modalTitle: {
    fontSize: '22px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '20px',
    borderBottom: '1px solid #e2e8f0',
    paddingBottom: '10px',
  },
  modalActions: {
    display: 'flex',
    gap: '15px',
    justifyContent: 'flex-end',
    marginTop: '30px',
  },
  btnEdit: {
    padding: '8px 16px',
    background: '#f59e0b',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background 0.2s',
  },
  tdActions: {
    padding: '12px',
    borderBottom: '1px solid #f1f5f9',
    color: '#1e293b',
    whiteSpace: 'nowrap',
  },
  // Estilos POS
  posSection: {
    marginTop: '20px',
    padding: '20px',
    background: 'linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%)',
    borderRadius: '12px',
    border: '2px solid #86efac',
  },
  posSectionTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#166534',
    marginTop: '0',
    marginBottom: '15px',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  posToggle: {
    marginBottom: '15px',
  },
  toggleLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
  },
  checkbox: {
    width: '20px',
    height: '20px',
    cursor: 'pointer',
  },
  toggleText: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#1e293b',
  },
  posFields: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '15px',
    marginTop: '15px',
  },
  posPreview: {
    gridColumn: '1 / -1',
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    padding: '12px',
    background: 'white',
    borderRadius: '8px',
    fontSize: '14px',
    color: '#475569',
  },
};

export default Materiales;